import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-repair-info',
  templateUrl: './repair-info.component.html',
  styleUrls: ['./repair-info.component.css']
})
export class RepairInfoComponent implements OnInit {

  singleObjectInfoData: any = []
  maintenanceScheduleList: any = []
  objectTemplateId = ""
  page: number = 1;
  count: number = 0;
  tableSize: number = 10;
  first: number = 0;
  tableSizes: any = [3, 6, 9, 12];
  cid: any
  groupTypeList: any = []
  selectAllChecked: any = false
  objectInfoList: any = []
  objectInfoListFilter: any = []
  singleObjectTemplateData: any = []
  objectTemplateList: any = []
  isLoading: any = false
  objectInfoId: any
  originalCost: any = ""
  currentCost: any = ""
  branch: any = ""
  department: any = ""
  make: any = ""
  model: any = ""
  location: any = ""
  objectCondition: any = ""
  givenName: any = ""
  serialNumber: any = ""
  locationList: any = []
  branchList: any = []
  repairInfoForm: any | FormGroup;
  isMaintenanceSchedule: any = false
  usersList: any = []
  maintenanceList: any = []


  assetConditions = [
    { value: 'Good', label: 'Good' },
    { value: 'UnderRepair', label: 'Under Repair' },
    { value: 'Scrap', label: 'Scrap' },
    { value: 'Faulty', label: 'Faulty' }
  ];

  maintenanceType = [
    {
      key: "Preventive Maintenance (PM) Schedule",
      value: "PreventiveMaintenanceSchedule"
    },
    {
      key: "Corrective Maintenance Schedule",
      value: "CorrectiveMaintenanceSchedule"
    },
    {
      key: "Predictive Maintenance Schedule",
      value: "PredictiveMaintenanceSchedule"
    },
    {
      key: "Condition-Based Maintenance (CBM)",
      value: "ConditionBasedMaintenance"
    }
  ]

  frequencyType = [
    {
      key: "Daily: Operational checks (temperature, pressure, noise, etc.)",
      value: "Daily"
    },
    {
      key: "Weekly: Lubrication, filter checks, fluid levels",
      value: "Weekly"
    },
    {
      key: "Monthly: In-depth inspections, cleaning, software updates",
      value: "Monthly"
    },
    {
      key: "Quarterly: Component replacements (belts, seals), diagnostics",
      value: "Quarterly"
    },
    {
      key: "Annually: Major overhauls, part replacements, certifications",
      value: "Annually"
    }
  ]

  isRepair: any = false
  showFilter: any = false
  isRepairDone: boolean = false;
  isRepairGiven: boolean = false;

  searchFilter: any = "";
  recordId: any = "";
  recordName: any = "";

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

  ngOnInit(): void {
    this.cid = sessionStorage.getItem('cid')
    // this.getAllObjectInfo()
    this.getAllGivenRepairByAndCid(true)

    this.getAllObjectTemplate()
    this.getAllLocation()
    this.getAllBranch()
    this.getUsersWithoutCustomers()
    this.repairInfoForm = this.fb.group({
      description: [''],
      repairGivenTo: [''],
      repairGivenDate: [''],
      repairExpectedEndDate: [''],
      userName: [''],
      phNo: [''],
      emailId: [''],
      lat: [''],
      lng: ['']
    })
  }

  closeRepair() {
    this.isRepair = false
    this.repairInfoForm.reset()
  }

  getMaintenanceType(type: any) {
    for (let list of this.maintenanceType) {
      if (list.value == type) {
        return list.key
      }
    }
    return ""
  }

  openRepair() {
    this.isRepair = !this.isRepair
  }

  onTableDataChange(event: any) {
    console.log(event)
    this.page = event.page + 1;
  }

  getAllObjectTemplate() {
    this.generic_service.getAllObjectTemplate().subscribe(
      (response: any) => {
        console.log(response)
        this.objectTemplateList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  toggleFilter() {
    this.showFilter = !this.showFilter
  }

  refreshTickets() {
    this.page = 1
    this.first = 0
    // this.getAllObjectInfo()
  }

  getObjectTemplateById(objectTemplateId: any) {
    this.generic_service.getObjectTemplateById(objectTemplateId.target.value).subscribe(
      (response: any) => {
        console.log(response)
        this.singleObjectTemplateData = []

        this.singleObjectTemplateData.push(response.response)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  openRepairDone() {
    this.isRepairDone = !this.isRepairDone
  }

  getObjectInfoById(objectInfoId: any) {
    this.objectInfoId = objectInfoId
    this.generic_service.getObjectInfoById(objectInfoId).subscribe(
      (response: any) => {
        console.log(response);
        this.singleObjectInfoData = []
        this.isRepairGiven = response.response.givenRepair

        this.singleObjectInfoData.push(response.response)
        this.getAllMaintenanceScheduleByAssetId(objectInfoId)
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllMaintenanceScheduleByAssetId(objectInfoId: any) {
    this.generic_service.getAllMaintenanceScheduleByAssetId(objectInfoId).subscribe(
      (response: any) => {
        console.log(response);
        this.maintenanceScheduleList = response.response
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getAllGivenRepairByAndCid(givenRepair: any) {
    this.generic_service.getAllGivenRepairByAndCid(givenRepair).subscribe(
      (response: any) => {
        console.log(response);
        this.objectInfoList = response.response || []
        this.objectInfoListFilter = response.response
        this.count = response.response.length
      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  // getAllObjectInfo(){
  //   this.generic_service.getAllObjectInfo().subscribe(
  //     (response:any)=>{
  //       console.log(response);
  //       this.objectInfoList = response.response
  //       this.objectInfoListFilter = response.response
  //       this.count = response.response.length
  //     },
  //     (error:any)=>{
  //       console.log(error)
  //     }
  //   )
  // }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res);
        this.usersList = res.response;
      }
    )
  }

  remove() {
    document.getElementById("closeModalButton")?.click()
    this.singleObjectTemplateData = []
    this.objectTemplateId = ""
  }

  closeRepairDone() {
    this.isRepairDone = false
    this.repairInfoForm.reset()
  }


  addRepairInfos(isRepair: any) {

    // for(let list of this.usersList){
    //   if(list.userId == Number(this.repairInfoForm.get('repairGivenTo').value)){
    //     this.repairInfoForm.patchValue({
    //       userName: list.userName,
    //     })
    //   }
    // }


    let body = {
      "version": 0,
      "isActive": true,
      "description": this.repairInfoForm.get('description').value,
      "to": "Good",
      "cid": Number(this.cid),
      "objectInfoId": this.objectInfoId,
      "repairInfo": {
        "repairGivenTo": this.repairInfoForm.get('repairGivenTo').value,
        "repairGivenDate": this.repairInfoForm.get('repairGivenDate').value,
        "repairExpectedEndDate": this.repairInfoForm.get('repairExpectedEndDate').value,
        "description": this.repairInfoForm.get('description').value,
        "userName": this.repairInfoForm.get('userName').value,
        "phNo": this.repairInfoForm.get('phNo').value,
        "emailId": this.repairInfoForm.get('emailId').value,
        "lat": "",
        "lng": "",
      },
      "givenRepair": isRepair
    }

    console.log(body)
    this.generic_service.updateObjectInfoByRepairInfo(body).subscribe(
      (response: any) => {
        console.log(response)
        this.closeRepair()
        this.getObjectInfoById(this.objectInfoId)
        this.toastr.success(response.message);
        this.isRepairDone = false;

      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.error.errors[0].description);
      }
    )
  }

  addObjectInfo() {

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "layerInfoId": 0,
      "name": this.singleObjectTemplateData[0]?.name,
      "type": this.singleObjectTemplateData[0]?.type,
      "group": this.singleObjectTemplateData[0]?.group,
      "originalCost": this.originalCost,
      "objectCondition": this.objectCondition,
      "givenName": this.givenName,
      "serialNumber": this.serialNumber,
      "conditionModifiedBy": [],
      "currentCost": this.currentCost,
      "branch": this.branch,
      "department": this.department,
      "make": this.make,
      "model": this.model,
      "location": this.location,
      "routeId": this.singleObjectTemplateData[0]?.routeId,
      "subGroups": this.singleObjectTemplateData[0]?.subGroups,
      "nameValue": this.singleObjectTemplateData[0]?.nameValue,
      "cid": this.singleObjectTemplateData[0]?.cid,
      "repairInfos": [],
    }

    console.log(body)
    this.generic_service.addObjectInfo(body).subscribe(
      (response: any) => {
        document.getElementById("closeModalButton")?.click()
        document.getElementById("closeModalButton1")?.click()

        for (let list of this.maintenanceList) {
          let body = {
            "version": 0,
            "isActive": true,
            "description": list.description,
            "assetId": response.response.objectInfoId,
            "assetName": response.response.givenName,
            "maintenanceType": [
              list.maintenanceType,
            ],
            "frequency": [
              list.frequency,
            ],
            "nextDueDate": list.nextDueDate,
            "lastPerformed": "",
            "cid": Number(this.cid)
          }

          this.addMaintenanceSchedule(body)
        }



        this.toastr.success(response.message);
        this.singleObjectTemplateData = []
        this.originalCost = ""
        this.currentCost = ""
        this.branch = ""
        this.department = ""
        this.objectCondition = ""
        this.givenName = ""
        this.location = ""
        this.serialNumber = ""
        // this.getAllObjectInfo()
        this.maintenanceList = []
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }



  addMaintenance() {
    this.maintenanceList.push(
      {
        "description": "",
        "maintenanceType": "",
        "frequency": "",
        "nextDueDate": "",
        "lastPerformed": "",
      }
    )
  }

  removeMaintenance(index: any) {
    this.maintenanceList.splice(index, 1)
  }

  addMaintenanceSchedule(body: any) {
    console.log(body)
    this.generic_service.addMaintenanceSchedule(body).subscribe(
      (response: any) => {
        console.log(response)
      },
      (error: any) => {
        this.toastr.error(error.error.errors[0].description);
        console.log(error)
      }
    )
  }


  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        console.log(res)
        this.locationList = res.response
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  getAllBranch() {
    this.generic_service.getBranch().subscribe(
      (response: any) => {
        this.branchList = response.response;
      }
    )
  }



  selectDelete(id: any, list: any) {
    this.objectInfoId = id;

    this.recordId = list.objectInfoId
    this.recordName = list.givenName
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  refreshAll() {
    this.page = 1
    this.first = 0
    this.searchFilter = ""
    this.getAllGivenRepairByAndCid(true)
  }

  getObjectInfoByWildSearchAndGivenRepair() {
    console.log(this.searchFilter)
    if (this.searchFilter == "" || this.searchFilter == null) {
      return
    }
    this.generic_service.getObjectInfoByWildSearchAndGivenRepair(this.searchFilter, true).subscribe(
      (res: any) => {
        if (res.response == null || res.response.length == 0 || res.response == undefined) {
          this.objectInfoList = []
          this.count = 0
          return

        }
        this.objectInfoList = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log(err);
      }
    );
  }



  deleteAsset() {
    this.generic_service.deleteObjectInfo(this.objectInfoId).subscribe(
      (response: any) => {
        console.log(response);
        document.getElementById("deleteModalButton1")?.click()
        // this.getAllObjectInfo()
        this.toastr.success(response.message)

      },
      (error: any) => {
        console.log(error)
        this.toastr.error(error.errors[0].description)
      }
    )
  }


  getAllModelByAndCid(model: any) {
    this.generic_service.getAllModelByAndCid(model).subscribe(
      (res: any) => {
        console.log('Model Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Model Error:', err);
      }
    );
  }

  getAllMakeByAndCid(make: any) {
    this.generic_service.getAllMakeByAndCid(make).subscribe(
      (res: any) => {
        console.log('Make Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Make Error:', err);
      }
    );
  }

  getAllByType(type: any) {
    this.generic_service.getAllByType(type).subscribe(
      (res: any) => {
        console.log('Type Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Type Error:', err);
      }
    );
  }

  getAllBySerialNumberAndCid(serialNumber: any) {
    this.generic_service.getAllBySerialNumberAndCid(serialNumber).subscribe(
      (res: any) => {
        console.log('Serial Number Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Serial Number Error:', err);
      }
    );
  }

  getAllByObjectConditionAndCid(objectCondition: any) {
    this.generic_service.getAllByObjectConditionAndCid(objectCondition).subscribe(
      (res: any) => {
        console.log('Object Condition Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Object Condition Error:', err);
      }
    );
  }

  getAllByBranchAndCid(branch: any) {
    this.generic_service.getAllByBranchAndCid(branch).subscribe(
      (res: any) => {
        console.log('Branch Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Branch Error:', err);
      }
    );
  }

  getAllByDepartmentAndCid(department: any) {
    this.generic_service.getAllByDepartmentAndCid(department).subscribe(
      (res: any) => {
        console.log('Department Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Department Error:', err);
      }
    );
  }

  getAllByGroup(group: any) {
    this.generic_service.getAllByGroup(group).subscribe(
      (res: any) => {
        console.log('Group Result:', res);
        this.objectInfoList = res.response
        this.objectInfoListFilter = res.response
        this.count = res.response.length
      },
      (err: any) => {
        console.log('Group Error:', err);
      }
    );
  }

  closeModal() {
    this.recordId = "";
    this.recordName = "";
  }


  assetCondition(condition: any) {
    for (let list of this.assetConditions) {
      if (list.value == condition) {
        return list.label
      }
    }
    return "--"

  }

}